import React from 'react';

import styled from '@emotion/styled';
import clsx from 'clsx';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsBuilding, BsCash, BsHouse, BsPerson, BsKey } from 'react-icons/bs';

import SaleIcon from '../SaleIcon';

const IconSpan = styled.span`
	position: relative;
	width: 2.125rem;
	height: 2.125rem;
	border-radius: 50%;
	font-size: 1.25rem;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	align-content: center;
	margin: 0;
	padding: 0;
	border: 1px solid transparent;
	cursor: pointer;

	.key-icon svg {
		transform: rotate(135deg);
	}

	&.icon-sm {
		width: 1.75rem;
		height: 1.75rem;
		font-size: 0.75rem;
	}

	&.icon-lg {
		width: 2.75rem;
		height: 2.75rem;
		font-size: 1.75rem;
	}
`;

interface DealTypeIconProps {
	iconType?: string;
	toolTipText?: string;
	className?: string;
	size?: string;
}

const DealTypeIcon = (props: DealTypeIconProps) => {
	const { iconType, toolTipText, className, size } = props;
	let elementStyles = null;
	let iconColor = null;
	let iconElement = null;

	switch (iconType) {
	case 'Our Listing':
		iconColor = 'pink';
		iconElement = <BsHouse />;
		break;
	case 'Buying':
		iconColor = 'info';
		iconElement = (
			<span className="key-icon">
				<BsKey />
			</span>
		);
		break;
	case 'Our Buyer':
		iconColor = 'indigo';
		iconElement = <BsPerson />;
		break;
	case 'Lease':
		iconColor = 'purple';
		iconElement = <BsBuilding />;
		break;
	case 'Other Income':
		iconColor = 'teal';
		iconElement = <BsCash />;
		break;
	case 'Sale':
		iconColor = 'orange';
		iconElement = <SaleIcon />;
		break;

	default:
		break;
	}

	elementStyles = `deal-type-icon ${size === 'sm' ? 'icon-sm' : size === 'lg' ? 'icon-lg' : ''} border-${iconColor} text-${iconColor} bg-${iconColor}-light`;

	return (
		<OverlayTrigger
			overlay={
				<Tooltip id="tooltip-icon">
					<span className="text-capitalize">
						{toolTipText ? toolTipText : iconType}
					</span>
				</Tooltip>
			}
			placement="top"
		>
			<IconSpan className={clsx(elementStyles, className)}>
				{iconElement}
			</IconSpan>
		</OverlayTrigger>
	);
};

export default DealTypeIcon;
